import { executeApp, get, put } from '@/utils/request'
import {
  CLASSROOM_USER_FUNCTION_PINNED,
  USER,
} from '@/api/defineRouting'

export function getUserInfo<T = any>(
  data: { user_id: string | number },
) {
  return get<T>({
    url: `/users-service/users/detail_user/${data.user_id}`,
  })
}

export function updateUserInfo<T = any>(
  id: string | number,
  data: any,
) {
  return put<T>({
    url: `/users-service/users/update_user/${id}`,
    data,
  })
}

export function getUserRoleInfo<T = any>(workspace_id: string | number) {
  return get<T>({
    url: '/users-service/role/get_role_by_user',
    data: { workspace_id },
  })
}

/**
 * User Function Pinned
 */

export function getListUserFunctionPinned<T = any>() {
  return executeApp<T>(CLASSROOM_USER_FUNCTION_PINNED.LIST, {}, 'post')
}

export function pinUserFunction<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_USER_FUNCTION_PINNED.PIN, data, 'post')
}

export function unpinUserFunction<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_USER_FUNCTION_PINNED.UNPIN, data, 'post')
}

export function saveUserFunction<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_USER_FUNCTION_PINNED.SAVE, data, 'post')
}

export function getListProvince<T = any>() {
  return executeApp<T>(USER.LIST_PROVINCE, {}, 'get')
}

export function getListDistrict<T = any>(data: any) {
  return executeApp<T>(USER.LIST_DISTRICT, data, 'get')
}

export function getListByRole<T = any>(data: any) {
  return executeApp<T>(USER.LIST_BY_ROLE, data, 'post')
}

export function getListAllUser<T = any>(data: any) {
  return executeApp<T>(USER.LIST_ALL, data, 'post')
}
